import { useCallback } from 'react'

import {
  GET_WAREHOUSE_STOCK_EXPORT,
  convertParams,
} from 'app/common/api/requests/food/warehouse/stock/export/get'

import { api } from 'app/api'
import { WarehouseStockExportParams } from 'app/common/types/warehouse/stock'

export function useWarehouseStockExportFile() {
  const download = useCallback(async (params: WarehouseStockExportParams) => {
    const res = await api.download(GET_WAREHOUSE_STOCK_EXPORT, {
      error: 'Не удалось подготовить файл для скачивания',
      filename: 'export.xlsx',
      params,
      convertions: {
        convertParams,
      },
    })
    return res !== null
  }, [])

  return {
    download,
  }
}
